import update from 'immutability-helper';
import SidebarSiteNavigationEnum from './SidebarSiteNavigationConstants';

const initialState = {
  isUserSessionsPanelOpen: false,
  navigationAction: SidebarSiteNavigationEnum.SIDEBAR_SITE_NAVIGATION_ACTION_SIGN,
  userSessions: [],
};

const SidebarSiteNavigationReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SidebarSiteNavigationEnum.SIDEBAR_SITE_NAVIGATION_SESSIONS_PANEL_CLOSE:
      return update(state, {
        isUserSessionsPanelOpen: { $set: false },
      });
    case SidebarSiteNavigationEnum.SIDEBAR_SITE_NAVIGATION_SESSIONS_PANEL_OPEN:
      return update(state, {
        isUserSessionsPanelOpen: { $set: true },
        navigationAction: { $set: action.navigationAction },
      });
    case SidebarSiteNavigationEnum.SIDEBAR_SITE_NAVIGATION_USER_SESSIONS_GET:
      return update(state, {
        userSessions: { $set: action.userSessions },
      });
    case SidebarSiteNavigationEnum.SIDEBAR_SITE_NAVIGATION_ACTION_SET:
      return update(state, {
        navigationAction: { $set: action.navigationAction },
      });
    default:
      return state;
  }
};

export default SidebarSiteNavigationReducer;



// WEBPACK FOOTER //
// ./src-react/SidebarSiteNavigation/SidebarSiteNavigationReducer.jsx